export const state = {
  isOpen: false,
  source: '',
  eventId: null,
}

export const getters = {}

export const actions = {
  openVideo: ({ commit }, payload) => {
    console.log('state')
    console.log(payload)
    commit('SET_VIDEO_EVENT_ID', payload.event_id)
    commit('SET_VIDEO_SOURCE', payload.source)
    commit('OPEN_VIDEO')
  },

  completeVideo: function({ commit, dispatch, state }, vue) {
    commit('CLOSE_VIDEO')
    dispatch('events/processEvent', {eventId: state.eventId} , { root: true })
  },

  populateFromDB: async ({ commit, dispatch, state }, payload) => {},
}

export const mutations = {
  OPEN_VIDEO: (state, content) => {
    state.isOpen = true
  },
  CLOSE_VIDEO: (state, content) => {
    state.isOpen = false
  },
  SET_VIDEO_SOURCE: (state, content) => {
    console.log(content)
    state.source = content
  },
  SET_VIDEO_EVENT_ID: (state, content) => {
    state.eventId = content
  },
}
